import React, { Component } from 'react'
import Tabletop from 'tabletop'
import _ from 'lodash'
import { SVGComponent } from '../svg'
import { data } from './data.js'
import { FilterComponent } from 'components/filter/component'
import { isMobile } from 'react-device-detect'

type Props = {
  council: string
  title: string
  sheetURL: string
}

type State = {
  data: string[]
  sortedData: string[]
  sr: string[]
  sortedSr: string[]
  nr: string[]
  sortedNr: string[]
}

export class ParliamentComponent extends Component<Props, State> {
  constructor(props: {}) {
    super(props)
    this.state = {
      data: [],
      sortedData: [],
      nr: [],
      sortedNr: [],
      sr: [],
      sortedSr: []
    }
  }

  componentWillMount() {
    // Party sort order
    const sortedParties = [
      'Andere link',
      'PdA',
      'Grüne',
      'SP',
      'GLP',
      'CVP',
      'EVP',
      'Andere',
      'Parteilos',
      'BDP',
      'FDP',
      'LDP',
      'SVP',
      'Lega',
      'MCG',
      'Andere rechts',
      'Keine'
    ]

    console.log('PRODUCTION VERSION')
    this.setState({
      data,
      sortedData: data.sort(
        (a, b) =>
          // sortedParties.indexOf(a.Partei) - sortedParties.indexOf(b.Partei)
          parseInt(a.Sitznummer) - parseInt(b.Sitznummer)
      ),
      nr: data.filter(el => el.Rat === 'Nationalrat'),
      sortedNr: data
        .filter(el => el.Rat === 'Nationalrat' && el.Elected !== 'Nein')
        .sort(
          (a, b) =>
            // sortedParties.indexOf(a.Partei) - sortedParties.indexOf(b.Partei)
            parseInt(a.Sitznummer) - parseInt(b.Sitznummer)
        ),
      sr: data.filter(el => el.Rat === 'Ständerat'),
      sortedSr: data
        .filter(el => el.Rat === 'Ständerat' && el.Elected !== 'Nein')
        .sort(
          (a, b) =>
            // sortedParties.indexOf(a.Partei) - sortedParties.indexOf(b.Partei)
            parseInt(a.Sitznummer) - parseInt(b.Sitznummer)
        )
    })
  }

  render() {
    return (
      <div className='parliament-container'>
        {this.state.data.length > 0 ? (
          <div>
            <SVGComponent
              data={this.state.sortedData}
              sr={this.state.sortedSr}
              nr={this.state.sortedNr}
              council={this.props.council}
            />
          </div>
        ) : (
          <div className='ui very basic vertical aligned segment'>
            <div className='ui active loader' />
          </div>
        )}
      </div>
    )
  }
}
